import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";


function EditContact({ id, role_id, address_id, onClose }) {

const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
const navigate = useNavigate();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
const [data, setData] = useState([]);
const [address, setAddress] = useState([]);
const [selectedAddressId, setSelectedAddressId] = useState(null);
const [isNewAddress, setIsNewAddress] = useState(false);

  useEffect(() => {
    const getContactDetails = async () => {
      try {
     //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/contact_detail/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setData(response.data.contact_detail);
        setAddress(response.data.contact_address || []);
    //    console.log(response.data);
        setValue("id",response.data.contact_detail.id);
        setValue("role_id",role_id);
        setValue("firstname",response.data.contact_detail.firstname);
        setValue("lastname",response.data.contact_detail.lastname);
        setValue("phone",response.data.contact_detail.phone);
        setValue("email",response.data.contact_detail.email);
        setValue("designation",response.data.contact_detail.designation);

if (address_id) {
        const findAddress = response.data.contact_address.find(
          (a) => a.id == address_id
        );

        if (findAddress) {
          setSelectedAddressId(findAddress.id);
          setIsNewAddress(false);

          setValue("address_selection", findAddress.id);
          setValue("address", findAddress.address);
          setValue("cover_address", findAddress.cover_address);
          setValue("comment", findAddress.comment);
          return;
        }
      }

 if (response.data.contact_address?.length > 0) {
        const first = response.data.contact_address[0];

        setSelectedAddressId(first.id);
        setIsNewAddress(false);

        setValue("address_selection", first.id);
        setValue("address", first.address);
        setValue("cover_address", first.cover_address);
        setValue("comment", first.comment);
      }
       
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getContactDetails();
  }, [id]);


  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/orders/edit_contact`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Contact update successfully!");
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 
 
  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Edit Contact</h4>
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="mb-2">
                    <label className="form-label">First Name *</label>
                    <input type="hidden" {...register("id")} />
                    <input type="hidden" {...register("role_id")} />
                    <input type="text" {...register("firstname", { required: "required" })} className={`form-control ${ errors.firstname && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Phone </label>
                    <input type="text" {...register("phone", { required: "required" })} className={`form-control ${ errors.phone && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                     <label className="form-label">Select Address *</label>
                    {address?.map((item, index) => (
                    <div key={item.id} className="form-check mb-2">
                        <input
                        {...register("address_selection")}
                        className="form-check-input"
                        type="radio"
                        value={item.id}
                        checked={selectedAddressId === item.id && !isNewAddress}
                        onChange={() => {
                            setSelectedAddressId(item.id);
                            setIsNewAddress(false);
                            setValue("address_selection", item.id);
                            // Fill inputs with selected address
                            setValue("address", item.address);
                            setValue("cover_address", item.cover_address);
                            setValue("comment", item.comment);
                        }}
                        />
                        <label className="form-check-label">
                        {selectedAddressId === item.id ? (
                            <strong>Current Address</strong>
                        ) : (
                            <strong>{`Address ${index + 1}`}</strong>
                        )}
                        </label>
                    </div>
                    ))}

                    {/* ADD NEW ADDRESS OPTION */}
                    <div className="form-check mt-3">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="address_selection"
                        value="new"
                        checked={isNewAddress}
                        onChange={() => {
                        setIsNewAddress(true);
                        setSelectedAddressId(null);
                        setValue("address_selection", "");  
                        // Clear input fields
                        setValue("address", "");
                        setValue("cover_address", "");
                        setValue("comment", "");
                        }}
                    />
                    <label className="form-check-label">Add New Address</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="mb-2">
                    <label className="form-label">Last name *</label>
                    <input type="text" {...register("lastname", { required: "required" })} className={`form-control ${ errors.lastname && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Email</label>
                    <input type="text" {...register("email", { required: "required" })} className={`form-control ${ errors.email && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Designation *</label>
                    <input type="text" {...register("designation", { required: "required" })} className={`form-control ${ errors.designation && "is-invalid"}`} />
                  </div>
                </div>
              </div>

                <div className="row mt-3">
                    <div className="col-md-12">
                    <div className="mb-2">
                        <label className="form-label">Address *</label>
                        <input
                        type="text"
                        {...register("address", { required: "required" })}
                        className={`form-control ${errors.address && "is-invalid"}`}
                        />
                    </div>

                    <div className="mb-2">
                        <label className="form-label">Cover Address *</label>
                        <input
                        type="text"
                        {...register("cover_address", { required: "required" })}
                        className={`form-control ${errors.cover_address && "is-invalid"}`}
                        />
                    </div>

                    <div className="mb-2">
                        <label className="form-label">Comment</label>
                        <textarea
                        {...register("comment")}
                        className="form-control"
                        ></textarea>
                    </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

}
export default EditContact;